import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatNumber' })
export class FormattedNumberPipe implements PipeTransform {
    transform(value: number) {
        return value > 999 ? (value / 1000).toFixed(1) + 'k' : value;
    }
}
